export const getDiffTime = (
  buy_timestamp: number,
  sell_timestamp: number = new Date().getTime() / 1000
) => {
  const time = sell_timestamp - buy_timestamp;
  const minute = time / 60;
  const hours = time / 60 / 60;
  const days = hours / 24;

  if (days > 1) {
    return `${Math.floor(days)}d`;
  }

  if (hours > 1) {
    return `${Math.floor(hours)}h`;
  }

  if (minute > 1) {
    return `${Math.floor(minute)}m`;
  }

  if (time < 60) {
    return `${time}s`
  }


  return undefined;
};

//保留n位小数
export const fomatDecimal = (value: number, n: number = 5) => {
  return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
}

// export const fomatDecimal = (num: number, max_num: number = 4) => {
//   if (!(num > 0)) return;
//   const arr = num.toString().split(".");
//   if (arr.length < 2) return num.toString();

//   const num_arr = String(arr[1]).split("");

//   let str = "";
//   let max_l = 1;

//   for (let i = 0; i < num_arr.length; i++) {
//     str += num_arr[i];
//     if (num_arr[i] !== "0") {
//       max_l++;
//     }
//     if (max_l >= max_num) break;
//   }

//   return `${arr[0]}.${str}`;
// };

export function roundedImage(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

export function download(selector: any) {
  // 通过 API 获取目标 canvas 元素
  const canvas = document.querySelector(selector);

  // 创建一个 a 标签，并设置 href 和 download 属性
  const el = document.createElement('a');
  // 设置 href 为图片经过 base64 编码后的字符串，默认为 png 格式
  el.href = canvas.toDataURL();
  el.download = '文件名称';
  
  // 创建一个点击事件并对 a 标签进行触发
  const event = new MouseEvent('click');
  el.dispatchEvent(event);
}

export const onShare = (address: string) => {
  const twTitle = '🏆 Do you remember Your 2022 NFT Glory Moments?\n\n    💎 Diamond Hand?\n    🧻 Paper Hand?\n    💰 Flipper Hero?\n\n    Check NOW!!!\n\n🎁 Get chance to EARN invitation link of @NFTTrack 👇 \n#NFT #NFTCommuntiy #2022NFTMoments\n';
  const url = encodeURIComponent(`${twTitle}https://nfttrack.ai${process.env.REACT_APP_SHARE_URL}?address=${address}`);
  window.open(`http://twitter.com/intent/tweet/?text=${url}`)
}